<template>
  <div>
    <span v-if="!!currentRequest">
      <rating-request-information
        class="mb-4"
        :request="currentRequest"
        :activityTypeList="types"
        @update="getRequests"
      ></rating-request-information>
    </span>
    <v-card outlined>
      <v-card flat>
        <v-card-title>
          Заявки на рейтинговую стипендию
        </v-card-title>

        <v-data-table
          dense
          :headers="headers"
          :items="requests"
          sort-by="semester"
          :sort-desc="true"
          @click:row="editRequest"
        >
          <template #item.semester="{item}">
            <span v-if="item.id == currentRequest.id">
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon class="mr-3" v-bind="attrs" v-on="on" color="green">
                    mdi-checkbox-marked-circle-outline
                  </v-icon>
                </template>

                Текущий семестр
              </v-tooltip>
            </span>
            {{ item.rating.semester.number }} семестр
            {{ item.rating.semester.name }}
          </template>
          <template #item.type="{item}">
            {{ item.type.typeName }}
          </template>
          <template #item.status="{item}">
            <div class="flex">
              <v-icon
                class="mr-3"
                v-bind="attrs"
                v-on="on"
                :color="getStatusColor(item.status)"
              >
                {{ getStatusIcon(item.status) }}
              </v-icon>

              <span> {{ getStatusName(item.status) }} </span>
            </div>
          </template>
        </v-data-table>

        <v-divider />
      </v-card>
    </v-card>
  </div>
</template>

<script>
import RatingRequestInformation from "./RatingRequestInformation.vue";

import {
  getUserRequestList,
  getCurrentRating,
  getActivityTypesByRating
} from "../../../services/rating.service";
import {
  getStatusName,
  getStatusColor,
  getStatusIcon
} from "../../../constants/status.constants";

export default {
  name: "RatingInformation",

  components: {
    RatingRequestInformation
  },

  props: {
    userId: { required: true }
  },

  data: () => ({
    currentRating: {},
    currentRequest: null,
    types: [],
    requests: [],
    headers: [
      { text: "Семестр", value: "semester" },
      { text: "Направление (деятельность)", value: "type" },
      { text: "Баллы", value: "points" },
      { text: "Статус", value: "status" }
    ],

    edit: false,
    selectedRequest: {}
  }),

  async mounted() {
    await this.getRating();
    this.getRequests();
  },

  methods: {
    getStatusName,
    getStatusColor,
    getStatusIcon,
    editRequest(item) {
      this.edit = true;
      this.selectedRequest = item;
    },
    async getRequests() {
      try {
        this.requests = await getUserRequestList(this.userId);
        this.currentRequest = this.requests.find(
          r => r.rating.id == this.currentRating.id
        ) || {
          id: 0,
          status: "new",
          userId: this.userId,
          rating: this.currentRating,
          type: { id: 0 }
        };
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    },
    async getRating() {
      try {
        this.currentRating = await getCurrentRating();
        this.types = await getActivityTypesByRating(this.currentRating.id);
      } catch (e) {
        this.$notify({
          text: e.response ? e.response.data.message : e,
          type: "error"
        });
      }
    }
  }
};
</script>

<style scoped></style>
